export const getTemplateSelectionKey = (instanceUniqueId) => (
  `promoshowcase.selectedTemplate.${String(instanceUniqueId || '').trim()}`
);

const getBrowserStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch (_error) {
    return null;
  }
};

export const readSelectedTemplateId = (instanceUniqueId, storage = getBrowserStorage()) => {
  if (!instanceUniqueId || !storage) return '';
  try {
    return String(storage.getItem(getTemplateSelectionKey(instanceUniqueId)) || '').trim();
  } catch (_error) {
    return '';
  }
};

export const persistSelectedTemplateId = (instanceUniqueId, templateId, storage = getBrowserStorage()) => {
  if (!instanceUniqueId || !storage) return;
  try {
    const normalized = String(templateId || '').trim();
    if (normalized) storage.setItem(getTemplateSelectionKey(instanceUniqueId), normalized);
    else storage.removeItem(getTemplateSelectionKey(instanceUniqueId));
  } catch (_error) {
    // Selection persistence is a convenience; storage restrictions must not break the builder.
  }
};

export const resolveTemplateSelection = ({ templates, currentTemplateId, persistedTemplateId, activeTemplateId, defaultTemplateId = 'ps_modern_01' }) => {
  const ids = new Set((Array.isArray(templates) ? templates : []).map((template) => String(template?.id || '')));
  const valid = (candidate) => candidate && ids.has(String(candidate));

  const selectedTemplateId = [currentTemplateId, persistedTemplateId, activeTemplateId, defaultTemplateId]
    .find(valid) || String(templates?.[0]?.id || '');

  return {
    selectedTemplateId,
    persistedSelectionWasStale: Boolean(persistedTemplateId && !valid(persistedTemplateId)),
  };
};
